import * as constants from '../constants';

const initialState = {};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.createRegistryPhyto.success: {
            return action.payload;
        }

        case constants.createRegistryPhyto.error: {
            return initialState;
        }

        case constants.createRegistryPhyto.try: {
            return {};
        }

        default:
            return state;
    }
}